import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ESignService } from 'src/app/services/e-sign.service';
import { UrlValidatorService } from 'src/app/services/url-validator.service';
import { DomainType } from 'src/app/enum/domain-type.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-aadhaar-sign',
  templateUrl: './aadhaar-sign.component.html',
  styleUrls: ['./aadhaar-sign.component.scss'],
  standalone: false,
})
export class AadhaarSignComponent implements OnInit {
  // ─── Inputs from Parent ────────────────────────────────────────────────────
  @Input() signatoryDetails: any = {};
  @Input() orderId: string;
  @Input() esignId: string;
  @Input() signatoryId: string;
  @Input() webcamImage: any = null;
  @Input() enableCaptureImage: boolean = true;
  @Input() userData: any;
  @Input() isChecked: boolean = false;

  // ─── Outputs to Parent ─────────────────────────────────────────────────────
  /** Emits when the emudhra flow completes so parent can refresh */
  @Output() signCompleted = new EventEmitter<void>();

  // ─── ViewChildren ──────────────────────────────────────────────────────────
  @ViewChild('emudhraSign') emudhraSign: TemplateRef<any>;
  @ViewChild('emudhraSignDSC') emudhraSignDSC: TemplateRef<any>;

  // ─── Emudhra / DSC State ───────────────────────────────────────────────────
  /** Derived from parent's signatoryDetails on init */
  selectMethod: string; // 'AADHAAR' | 'DSC'
  signTypeDSC: boolean = false;

  pdfSource: SafeResourceUrl; // URL for Aadhaar iframe / DSC form action
  parameters: {
    Parameter1: string;
    Parameter2: string;
    Parameter3: string;
  };
  emudhraParms: any = {};
  aadhaarParms: any;

  // ─── File-corruption / retry ───────────────────────────────────────────────
  showFileCorruptedDialog: boolean = false;

  // ─── Loading overlay ───────────────────────────────────────────────────────
  isLoading: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private eSignService: ESignService,
    private messageService: MessageService,
    private urlValidator: UrlValidatorService,
  ) {}

  ngOnInit(): void {
    // Derive emudhra configuration from signatoryDetails passed by parent
    this.selectMethod = this.signatoryDetails?.sign_method;
    this.emudhraParms = this.signatoryDetails?.emudhra_gateway ?? {};
    this.signTypeDSC = this.selectMethod === 'DSC';

    const signUrl = this.signatoryDetails?.sign_url;

    if (this.selectMethod === 'AADHAAR') {
      this.aadhaarParms = this.emudhraParms?.aadhaar_param;
      if (
        signUrl &&
        this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)
      ) {
        this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
      }
    } else if (this.selectMethod === 'DSC') {
      if (
        signUrl &&
        this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)
      ) {
        this.pdfSource = this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
      }
      this.parameters = {
        Parameter1: this.emudhraParms?.Parameter1,
        Parameter2: this.emudhraParms?.Parameter2,
        Parameter3: this.emudhraParms?.Parameter3,
      };
    }

    // Check if returning from a failed retry redirect
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('retry') === 'true') {
      this.showFileCorruptionModal();
    }
  }

  // ──────────────────────────────────────────────────────────────────────────
  // AADHAAR SIGN  (iframe modal)
  // ──────────────────────────────────────────────────────────────────────────

  // loadEsignData(content: TemplateRef<any>): void {
  //   this.isLoading = true;

  //   // Webcam guard: if capture is required but no image taken, abort
  //   if (this.enableCaptureImage && !this.webcamImage) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Image Required',
  //       detail: 'Image is not captured properly. Please capture image again.'
  //     });
  //     this.isLoading = false;
  //     return;
  //   }

  //   this.sendUserDetails();

  //   this.eSignService
  //     .getExternalSignLink(this.signatoryId, this.orderId)
  //     .subscribe((res) => {
  //       // No sign_url in response
  //       if (!res['content'] || !res['content']['sign_url']) {
  //         this.isLoading = false;
  //         this.messageService.add({
  //           severity: 'warn',
  //           detail:
  //             res['message'] ||
  //             'Another signatory is currently signing. Please try after 10 minutes.'
  //         });
  //         return;
  //       }

  //       // Empty content object
  //       if (res['content'] && Object.keys(res['content']).length === 0) {
  //         this.isLoading = false;
  //         this.messageService.add({ severity: 'warn', detail: res['message'] });
  //         return;
  //       }

  //       this.isLoading = false;
  //       const signUrl = res['content'].sign_url;

  //       if (this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)) {
  //         this.pdfSource =
  //           this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
  //       } else {
  //         return;
  //       }

  //       // Open Aadhaar iframe modal
  //       this.modalService
  //         .open(content, {
  //           size: 'md',
  //           ariaLabelledBy: 'modal-basic-title',
  //           backdrop: 'static',
  //           keyboard: false
  //         })
  //         .result.then(
  //           (result) => {
  //             console.log('Aadhaar modal closed:', result);
  //           },
  //           (reason) => {
  //             console.log('Aadhaar modal dismissed:', reason);
  //           }
  //         );
  //     });
  // }

  loadEsignData(content: TemplateRef<any>): void {
    if (this.isLoading) {
      return; // a click is already in flight - don't start a second eMudhra session
    }
    this.isLoading = true;

    // Strict Guard Check
    if (this.enableCaptureImage && !this.webcamImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Image Required',
        detail:
          'Camera access is required. Please ensure your webcam is enabled and photo is captured properly.',
      });
      this.isLoading = false;
      return;
    }

    const userDataPayload = {
      browser_data: this.userData,
      esign_id: this.esignId,
      signatory_id: this.signatoryId,
      user_image: this.webcamImage,
    };

    // Strict Pipeline Execution
    this.eSignService.sendUserDetails(userDataPayload).subscribe({
      next: () => {
        this.eSignService
          .getExternalSignLink(this.signatoryId, this.orderId)
          .subscribe({
            next: (res: any) => {
              // <--- Yahan dhyan do
              if (!res['content'] || !res['content']['sign_url']) {
                this.isLoading = false;
                this.messageService.add({
                  severity: 'warn',
                  detail:
                    res['message'] ||
                    'Another signatory is currently signing. Please try after 10 minutes.',
                });
                return;
              }
              if (res['content'] && Object.keys(res['content']).length === 0) {
                this.isLoading = false;
                this.messageService.add({
                  severity: 'warn',
                  detail: res['message'],
                });
                return;
              }

              this.isLoading = false;
              const signUrl = res['content'].sign_url;

              if (
                this.urlValidator.isValidRedirectUrl(
                  signUrl,
                  DomainType.EMUDHRA,
                )
              ) {
                this.pdfSource =
                  this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
              } else {
                this.eSignService.reportUnopenableSignLink(signUrl, this.orderId);
                return;
              }

              this.modalService.open(content, {
                size: 'md',
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                keyboard: false,
              });
            },
            error: () => {
              this.isLoading = false;
              this.messageService.add({
                severity: 'error',
                detail: 'Failed to fetch signing link.',
              });
            },
          });
      },
      error: (err) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Verification Failed',
          detail:
            err?.error?.message ||
            'Audit trail verification failed. Please allow camera access.',
        });
      },
    });
  }

  // ──────────────────────────────────────────────────────────────────────────
  // DSC SIGN  (form POST to emSigner portal)
  // ──────────────────────────────────────────────────────────────────────────

  loadEsignDataDSC(): void {
    // DSC webcam guard is intentionally commented out in the original —
    // keeping same behaviour here; just call sendDSCSignFORM directly.
    this.sendDSCSignFORM();
  }

  // sendDSCSignFORM(): void {
  //   this.sendUserDetails();

  //   this.eSignService
  //     .getExternalSignLink(this.signatoryId, this.orderId)
  //     .subscribe((res) => {
  //       if (!res['content'] || !res['content']['sign_url']) {
  //         this.isLoading = false;
  //         this.messageService.add({
  //           severity: 'warn',
  //           detail:
  //             res['message'] ||
  //             'Another signatory is currently signing. Please try after 10 minutes.'
  //         });
  //         return;
  //       }

  //       if (res['content'] && Object.keys(res['content']).length === 0) {
  //         this.messageService.add({ severity: 'warn', detail: res['message'] });
  //         return;
  //       }

  //       const signUrl = res['content'].sign_url;
  //       if (this.urlValidator.isValidRedirectUrl(signUrl, DomainType.EMUDHRA)) {
  //         this.pdfSource =
  //           this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
  //       } else {
  //         return;
  //       }

  //       this.parameters = {
  //         Parameter1: res['content'].emudhra_gateway?.Parameter1,
  //         Parameter2: res['content'].emudhra_gateway?.Parameter2,
  //         Parameter3: res['content'].emudhra_gateway?.Parameter3
  //       };

  //       // Open DSC redirect modal, then auto-submit the form after 3 s
  //       this.modalService
  //         .open(this.emudhraSignDSC, {
  //           size: 'md',
  //           ariaLabelledBy: 'modal-basic-title',
  //           backdrop: 'static',
  //           keyboard: false,
  //           centered: true
  //         })
  //         .result.then(
  //           (result) => {
  //             console.log('DSC modal closed:', result);
  //           },
  //           (reason) => {
  //             console.log('DSC modal dismissed:', reason);
  //           }
  //         );

  //       setInterval(() => {
  //         this.submitForm();
  //       }, 3000);
  //     });
  // }

sendDSCSignFORM(): void {
  if (this.enableCaptureImage && !this.webcamImage) {
    this.messageService.add({
      severity: 'error',
      summary: 'Image Required',
      detail:
        'Camera access is required. Please ensure your webcam is enabled and photo is captured properly before DSC.',
    });
    return;
  }

  if (this.isLoading) {
    return; // a click is already in flight - don't start a second eMudhra session
  }
  this.isLoading = true;
  const data = {
    browser_data: this.userData,
    esign_id: this.esignId,
    signatory_id: this.signatoryId,
    user_image: this.webcamImage,
  };

  this.eSignService.sendUserDetails(data).subscribe({
    next: () => {
      this.eSignService
        .getExternalSignLink(this.signatoryId, this.orderId)
        .subscribe({
          next: (res: any) => {
            if (!res['content'] || !res['content']['sign_url']) {
              this.isLoading = false;
              this.messageService.add({
                severity: 'warn',
                detail:
                  res['message'] ||
                  'Another signatory is currently signing. Please try after 10 minutes.',
              });
              this.eSignService.checkForImageCaptureRefresh(res['message']);
              return;
            }
            
            // 2. Check if content object is empty
            if (res['content'] && Object.keys(res['content']).length === 0) {
              this.isLoading = false;
              this.messageService.add({
                severity: 'warn',
                detail: res['message'],
              });
              this.eSignService.checkForImageCaptureRefresh(res['message']);
              return;
            }

            const signUrl = res['content'].sign_url;
            if (
              this.urlValidator.isValidRedirectUrl(
                signUrl,
                DomainType.EMUDHRA,
              )
            ) {
              this.pdfSource =
                this.sanitizer.bypassSecurityTrustResourceUrl(signUrl);
            } else {
              this.isLoading = false;
              this.eSignService.reportUnopenableSignLink(signUrl, this.orderId);
              return;
            }

            this.parameters = {
              Parameter1: res['content'].emudhra_gateway?.Parameter1,
              Parameter2: res['content'].emudhra_gateway?.Parameter2,
              Parameter3: res['content'].emudhra_gateway?.Parameter3,
            };

            this.modalService.open(this.emudhraSignDSC, {
              size: 'md',
              ariaLabelledBy: 'modal-basic-title',
              backdrop: 'static',
              keyboard: false,
              centered: true,
            });

            setTimeout(() => {
              this.submitForm();
            }, 3000);
          },
          error: () => {
            this.isLoading = false;
            this.messageService.add({
              severity: 'error',
              detail: 'Failed to fetch DSC signing link.',
            });
          },
        });
    },
    error: (err) => {
      this.isLoading = false;
      const errMsg = err?.error?.message || 'Audit trail verification failed. Cannot proceed to DSC.';
      
      this.messageService.add({
        severity: 'error',
        summary: 'Verification Failed',
        detail: errMsg,
      });
      
      this.eSignService.checkForImageCaptureRefresh(errMsg);
    },
  });
}


  submitForm(): void {
    const form = document.getElementById('signDocForm') as HTMLFormElement;
    if (form) form.submit();
  }

  closeEmudhraModel(): void {
    this.modalService.dismissAll();
  }

  // ──────────────────────────────────────────────────────────────────────────
  // FILE CORRUPTION  (retry flow)
  // ──────────────────────────────────────────────────────────────────────────

  showFileCorruptionModal(): void {
    this.showFileCorruptedDialog = true;
  }

  onRetryClicked(): void {
    const url = new URL(window.location.href);
    if (
      this.urlValidator.isValidRedirectUrl(url.toString(), DomainType.DOQFY)
    ) {
      url.searchParams.delete('retry');
      window.history.replaceState({}, document.title, url.toString());
      this.showFileCorruptedDialog = false;
    }
  }

  onCloseModal(): void {
    this.showFileCorruptedDialog = false;
  }

  // ──────────────────────────────────────────────────────────────────────────
  // USER DETAILS  (sends browser/webcam data before signing)
  // ──────────────────────────────────────────────────────────────────────────

  // sendUserDetails(): void {
  //   if (!this.userData) return;
  //   if (this.enableCaptureImage && !this.webcamImage) {
  //     this.messageService.add({
  //       severity: 'warn',
  //       summary: 'Image Required',
  //       detail: 'Image is not captured properly. Please capture image again.',
  //     });
  //     return;
  //   }
  //   const data = {
  //     browser_data: this.userData,
  //     esign_id: this.esignId,
  //     signatory_id: this.signatoryId,
  //     user_image: this.webcamImage,
  //   };
  //   this.eSignService.sendUserDetails(data).subscribe(() => {});
  // }

  sendUserDetails(): void {
  if (!this.userData) {
    return;
  }

  if (this.enableCaptureImage && !this.webcamImage) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Image Required',
      detail: 'Image is not captured properly. Please capture image again.',
    });
    return;
  }
  const data = {
    browser_data: this.userData,
    esign_id: this.esignId,
    signatory_id: this.signatoryId,
  };

  this.eSignService.sendUserDetails(data).subscribe({
    next: (res) => {
      console.log('[Audit Trail] Browser configuration data synced successfully.');
    },
    error: (err) => {
      console.error('[Audit Trail] Error updating browser profile:', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Sync Failure',
        detail: err?.error?.message || 'Failed to update browser configuration profile. Please try again.',
      });
    }
  });
}
}
